import { usersClearCurrentUserReducer } from '@slices/users/users-clear-current-user';
import { usersSetUserReducer } from '@slices/users/users-set-user';

import { appCreateSlice } from '@store/rtk';

import { UsersState } from './types';
import { usersSetLoginLockReducer } from './users-set-login-lock';

export const usersDefaultState: UsersState = {
  currentUser: undefined,
};

const usersSlice = appCreateSlice({
  name: 'users',
  initialState: usersDefaultState,
  reducers: {
    usersSetUser: usersSetUserReducer,
    usersSetLoginLock: usersSetLoginLockReducer,
    usersClearCurrentUser: usersClearCurrentUserReducer,
  },
});

export const {
  actions: { usersSetUser, usersClearCurrentUser, usersSetLoginLock },
  reducer: usersReducer,
} = usersSlice;
